import { Title, Texts, Media } from "../Object";
import { Space } from "../Layout";
import { Scroll } from "../Animation";

const About = (props) => {
  return (
    <>
      <div className="l-row">
        <Title slug="about" type="border" />

        <Space size={['64px 0 0', '48px 0 0']}>
          <div className="c-grid__wrap--body-media" data-state="align-center">
            <Scroll>
              <div>
                <Texts slug="about/title" />
                <Space size={["40px 0 0", "32px 0 0"]}>
                  <Texts slug="about/body" />
                </Space>
              </div>
            </Scroll>

            <Media src="about/media" alt="About image" />
          </div>
        </Space>
      </div>
    </>
  );
};

export default About;
